import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-B3RFSCXG73';
const GTAG_SCRIPT_SRC = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;

const loadGtagScript = () => {
  if (typeof window === 'undefined') return;
  if (window.__gtagLoaded) return;
  if (document.querySelector(`script[src^="https://www.googletagmanager.com/gtag/js"]`)) {
    window.__gtagLoaded = true;
    return;
  }
  const s = document.createElement('script');
  s.async = true;
  s.src = GTAG_SCRIPT_SRC;
  document.head.appendChild(s);
  window.__gtagLoaded = true;
};

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  const initializeGoogleAnalytics = () => {
    loadGtagScript();
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
      window.gtag('config', GA_MEASUREMENT_ID);
    }
  };

  const disableGoogleAnalytics = () => {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const cookieName = cookie.split('=')[0].trim();
      if (cookieName.startsWith('_ga') || cookieName.startsWith('_gid')) {
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.mapprints.de`;
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=mapprints.de`;
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
      }
    }
  };

  useEffect(() => {
    const cookiePreference = localStorage.getItem('cookieConsent');
    const analyticsPreference = localStorage.getItem('analyticsConsent');

    setIsVisible(cookiePreference === null);

    if (analyticsPreference === 'true') {
      initializeGoogleAnalytics();
    }

    const reopen = () => setIsVisible(true);
    window.addEventListener('open-cookie-settings', reopen);
    return () => window.removeEventListener('open-cookie-settings', reopen);
  }, []);

  const handleCookieChoice = (accepted, allowAnalytics = false) => {
    localStorage.setItem('cookieConsent', accepted ? 'true' : 'false');
    localStorage.setItem('analyticsConsent', allowAnalytics ? 'true' : 'false');
    setIsVisible(false);

    if (allowAnalytics) {
      initializeGoogleAnalytics();
    } else {
      disableGoogleAnalytics();
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 z-50">
      <div className="container mx-auto max-w-4xl flex flex-col gap-4">
        <div className="text-sm">
          Diese Website verwendet Cookies. Mit der Nutzung unserer Dienste erklären Sie sich damit
          einverstanden, dass wir Cookies verwenden.
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link to="/privacy" className="text-sm underline">
            Details in der Datenschutzerklärung
          </Link>
          <div className="flex gap-4">
            <button
              onClick={() => handleCookieChoice(true, false)}
              className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-md text-sm transition-colors"
            >
              Nur notwendige Cookies
            </button>
            <button
              onClick={() => handleCookieChoice(true, true)}
              className="bg-white hover:bg-gray-100 text-gray-900 px-4 py-2 rounded-md text-sm transition-colors"
            >
              Alle akzeptieren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
